import priorityOptionsData from '@/utilities/priorityOptionsData';
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import useTranslate from '@/utilities/composables/useTranslate';
import { computed } from 'vue';

export default function usePriorityOptions() {
  const { iconPath } = useCustomIcon();
  const { translate } = useTranslate();

  const priorityOptions = computed(() => {
    return priorityOptionsData.map((priority) => {
      return {
        ...priority,
        label: translate(priority.label),
        customIconName: iconPath(priority.icon),
      };
    });
  });

  return {
    priorityOptions,
  };
}
